export default "__VITE_ASSET__9fecacc5__"